/**
 * Created by asiulik on 19.05.2017.
 */

define(['jquery', 'lodash', '../pageConst'], function ($, _, PageConst) {


    var changePageConst = PageConst.changePageConst['default'];
    var $content = $(PageConst.changePageConst.global.content);
    var $pageNav = $('#p__header');
    var $body = $('body');

    var BODY_NAME = 'body-fake';

    function changePageSuccessAction(data, $link) {

        var _this = this;

        data = data.replace(
            new RegExp('<body(?=(\\s|>))', 'g'),
            '<' + BODY_NAME
        ).replace(
            new RegExp('</body>', 'g'),
            '</' + BODY_NAME + '>'
        );

        var linkConfig = {};

        try {
            var elementIdFromLink = $link.data('pageContainer');
            linkConfig = $link.data('linkConfig') || {};
        } catch(e){}

        data = this.forceUpdateContentElements(linkConfig.forceUpdateModules || [], data);

        var $data = $(data);

        var contentSelector =  elementIdFromLink || PageConst.changePageConst.global.content;

        var $dataContent = $data.find(contentSelector);

        if ((!$dataContent || !$dataContent.length) && contentSelector !== PageConst.changePageConst.global.content) {
            contentSelector = PageConst.changePageConst.global.content;
            $dataContent = $data.find(contentSelector);
        }

        $content = $(contentSelector);
        
        var $dataBody = $data.filter(function(element1, element){
            return element.tagName == BODY_NAME.toUpperCase()
        })[0];

        $body.attr('class', $($dataBody).attr('class'));

        var $nav = $data.find('.p__header__content').parent();

        var navClassList = $nav.attr('class');

        $pageNav.attr('class', navClassList);

        if(!$dataContent || !$dataContent.length)
            throw new Error('response page contain incorrect structure: ' + PageConst.changePageConst.global.content + ' selector not found.')

        $content.removeClass(changePageConst.contentClassLoading)
            .addClass(changePageConst.contentClassLoaded);

        _.delay(function () {

            $content.removeClass(changePageConst.contentClassLoaded)
                .html($dataContent.html())
                .addClass(changePageConst.contentClassDone);

            _this.setPageData($data);

            _this.emit('getPageDone', {data: $data});

            _.delay(function () {

                $content.removeClass(changePageConst.contentClassDone)
                    .addClass(changePageConst.contentClassEnd);

                _this.emit('getPageAnimationDone');
                $('#pageLoader').addClass('preloader--hidden');

            }, 100)

        }, changePageConst.animationDuration)

    }

    return function (url, animationConfig, $link) {

        var _this = this;
        $content.removeClass(changePageConst.contentClassEnd);

        $('#pageLoader').removeClass('preloader--hidden');

        this.ajaxPage(url)
            .done(function (data) {

                if (data === 'redirect') {
                    return;
                }

                return changePageSuccessAction.call(_this, data, $link);

            })
            .fail(function (data) {

                try {

                    changePageSuccessAction.call(_this, data.responseText, $link);

                } catch (e) {

                    $content
                        .removeClass(changePageConst.contentClassLoading)
                        .addClass(changePageConst.contentClassFail);

                    _this.emit('getPageFail');

                    _.delay(function () {

                        $content.removeClass(changePageConst.contentClassFail)
                            .addClass(changePageConst.contentClassEnd);

                        //this.preloader.hide();

                    }, changePageConst.animationDuration + 100);

                }
            })
    }
});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/changePageAnimations/changePageDefault.js